import React from 'react';
import { UserType, UserTypeNameMap } from './constant';

import './index.less';

interface UserTypeTipProps {
  userType: UserType;
  repickType: () => void;
}

const UserTypeTip: React.FC<UserTypeTipProps> = (props) => {
  const { userType, repickType } = props;

  return <div className={'user-type-tip'}>
    <div className='left'>
      您的身份: {UserTypeNameMap[userType]}
    </div>
    <div className='right'>
      <a className='link' onClick={repickType}>修改身份</a>
    </div>
  </div>;
};

export default React.memo(UserTypeTip);
